import { StyleInterface } from '~/payload-types';

type StyleBlockProps = StyleInterface & {};

const StyleBlock = (props: StyleBlockProps) => {
  return <style>{props.style}</style>;
};

export default StyleBlock;
